import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/** ***************** Update Highmark Rules Start *********************** */
export const highmarkRulesAdd = (addData: any) => {
	const data = {
		UpdateHighmarkRulesDataToken: addData,
	};
	const url = `${API_URL}updateHighmarkRules`;
	return makeApiCall(url, data);
};
/** ***************** Update Highmark Rules End *********************** */

/** ***************** Fetch Highmark Rules Start *********************** */
export const highmarkRulesFetch = (fetchData: any) => {
	const data = {
		FetchHighmarkRulesToken: fetchData,
	};
	const url = `${API_URL}getAllHighmarkRuleLists`;
	return makeApiCall(url, data);
};
/** ***************** Fetch Highmark Rules End *********************** */
